import { Icon, SiteHeader } from "@jkast90/kast-common/ui";
import { useSession } from "@jkast90/kast-common/auth";
import { useOnline } from "@jkast90/kast-common/offline";
import { OfflineChip } from "../../auth/components/AuthMenu";
import { AccountControls } from "../account";

const LINKS = [
  { href: "/about", label: "About", icon: <Icon name="info" size={20} className="icon" /> },
  { href: "/library", label: "Library", icon: <Icon name="grid_view" size={20} className="icon" /> },
  {
    href: "/controllers",
    label: "Controllers",
    icon: <Icon name="videogame_asset" size={20} className="icon" />,
  },
];

/**
 * The header of every page but the player: the brand linking home, About, the
 * library and controller profiles, then at the end the account bar: Admin
 * (admins with admin tools on), the Settings gear and the profile button
 * (Sign in when signed out). Sign out is on the profile page.
 */
export default function TopBar() {
  const { status } = useSession();
  const online = useOnline();
  return (
    <SiteHeader
      className="site-top"
      sticky
      brand={{ logo: "/icons/favicon-64.png", alt: "CloudBoy", title: "CloudBoy" }}
      links={LINKS}
      account={
        <AccountControls className="auth" canSignIn={online}>
          {!online && <OfflineChip signedIn={status === "signedIn"} />}
        </AccountControls>
      }
    />
  );
}
